export const isValidAgeRange = (input: string): boolean =>
  input === "age-07-11yrs" ||
  input === "age-11-14yrs" ||
  input === "age-14-16yrs" ||
  input === "age-16-18yrs" ||
  input === "age-18+yrs";
